export const videoCatalog = {
  tim: {
    productId: 'tim',
    badge: 'TIM Helhedsløsning',
    productName: 'Medimi®Smart (TIM)',
    productPath: '/medimi-smart/tim',
    title: 'Se Medimi®Smart (TIM) i aktion',
    subtitle: 'Få et indblik i, hvordan TIM-systemet skaber en sikker, ubrudt og fuldt integreret værdikæde fra læge til borger.',
    sections: [
      {
        title: 'Animerede videoer (TIM)',
        videos: [
          {
            id: 'tim-1',
            slug: 'hvad-er-tim',
            aliases: ['tim-1', '1-hvad-er-tim', 'hvad-er-tim'],
            title: '1. Hvad er TIM?',
            duration: '3:53',
            description: 'En grundlæggende introduktion til TIM-systemet og dets funktioner i hverdagen.',
            longDescription: 'Se hvordan TIM-systemet fungerer som en intelligent medicindispenser i borgerens hjem. Videoen forklarer den komplette proces fra ordination og apotek til rettidig og præcis dosering af tabletter.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/1-hvad-er-tim-underteksterdansk.mp4',
            poster: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/mediccare-flow-2.jpg',
            subtitle: null,
            hasSubtitles: true,
            subtitles: [],
            category: 'Animerede præsentationsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          },
          {
            id: 'tim-9',
            slug: 'demografien-og-fremtidens-udfordringer',
            aliases: ['tim-9', '2-demografien-og-fremtidens-udfordringer', 'demografien-og-fremtidens-udfordringer'],
            title: '2. Demografien og fremtidens udfordringer',
            duration: '1:45',
            description: 'Hvordan vi løser fremtidens velfærdsudfordringer med intelligent medicinhåndtering.',
            longDescription: 'Den demografiske udvikling betyder flere ældre og færre hænder i sundhedssektoren. Lær hvordan intelligent velfærdsteknologi som TIM sikrer høj kvalitet i plejen trods stigende pres på sundhedsvæsenet.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/mediccare-demografien-viral-film-1.mp4',
            poster: '/Kundebilleder/imgi_5_flextech.png',
            category: 'Animerede præsentationsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          },
          {
            id: 'tim-7',
            slug: 'arbejdskraftbesparende-loesninger',
            aliases: ['tim-7', '3-arbejdskraftbesparende-loesninger', 'arbejdskraftbesparende-loesninger'],
            title: '3. Arbejdskraftbesparende løsninger',
            duration: '1:13',
            description: 'Se hvordan TIM frigiver værdifulde varme hænder og ressourcer i den kommunale plejesektor.',
            longDescription: 'Gennem automatisering af den daglige medicinudlevering kan hjemmeplejen reducere unødvendige køre- og doseringsture, så personalet kan fokusere på nærvær og kompleks omsorg.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/mediccare-arbejdskraftbesparende-viral-film-2.mp4',
            poster: '/Kundebilleder/imgi_4_omsorgssystem.png',
            category: 'Animerede præsentationsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          },
          {
            id: 'tim-8',
            slug: 'borgerne-kan-godt-selv',
            aliases: ['tim-8', '4-borgerne-kan-godt-selv', 'borgerne-kan-godt-selv'],
            title: '4. Borgerne kan godt selv',
            duration: '0:52',
            description: 'En inspirerende film om, hvordan TIM styrker borgernes selvstændighed og livskvalitet.',
            longDescription: 'Når borgerne selv tager kontrol over deres medicinering ved hjælp af lyd- og lyssignaler, øges deres frihed og selvværd markant uden at gå på kompromis med patientsikkerheden.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/mediccare-borgerne-kan-godt-viral-film-3.mp4',
            poster: '/Kundebilleder/imgi_2_medimi.jpg',
            category: 'Animerede præsentationsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          },
          {
            id: 'tim-10',
            slug: 'problemstilling-og-loesning',
            aliases: ['tim-10', '5-problemstilling-og-loesning', 'problemstilling-og-loesning-2017'],
            title: '5. Problemstilling og løsning (2017)',
            duration: '4:45',
            description: 'Baggrunden for udviklingen af TIM og de problemer, systemet løser i sundhedssektoren.',
            longDescription: 'En historisk og faglig gennemgang af medicineringsfejl i kommunerne og den visionære løsning, der dannede grundlaget for TIM-helhedsløsningen.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/tim-problemstilling-og-loesning-2016_1.mp4',
            poster: '/Kundebilleder/imgi_9_helhedsloesning.jpg',
            category: 'Animerede præsentationsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          }
        ]
      },
      {
        title: 'Funktionsvideoer',
        videos: [
          {
            id: 'tim-2',
            slug: 'hvordan-virker-tim',
            aliases: ['tim-2', 'hvordan-virker-tim', 'hvordan-virker-den'],
            title: 'a) Hvordan virker TIM?',
            duration: '0:46',
            description: 'En visuel gennemgang af dispenserens indre mekanik, sensorer og daglige funktion.',
            longDescription: 'Se detaljerne i, hvordan TIM opbevarer op til 16 forskellige præparater i separate magasiner, optæller de korrekte piller ved hjælp af præcise optiske sensorer og udleverer dem i en ren engangsbæger.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/tim-hvordan-virker-den-1_1.mp4',
            poster: '/Kundebilleder/imgi_2_medimi.jpg',
            category: 'Funktionsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          },
          {
            id: 'tim-3',
            slug: 'hvorfor-vaelge-en-pillerobot',
            aliases: ['tim-3', 'hvorfor-vaelge-en-pillerobot', 'hvorfor-en-pillerobot'],
            title: 'b) Hvorfor vælge en pillerobot?',
            duration: '1:57',
            description: 'Fordelene ved en fuldautomatisk pillerobot frem for traditionelle doseringsæsker.',
            longDescription: 'Sammenligning mellem manuelle doseringsæsker, rulleposer og TIM. Se hvorfor realtidsændring i ordinationer og direkte sky-integration giver uovertruffen patientsikkerhed.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/tim-hvorfor-en-pillerobot.mp4',
            poster: '/Kundebilleder/imgi_7_levering.png',
            category: 'Funktionsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          },
          {
            id: 'tim-4',
            slug: 'hvordan-fremtidsdoserer-man',
            aliases: ['tim-4', 'hvordan-fremtidsdoserer-man', 'fremtidsdosering'],
            title: 'c) Hvordan fremtidsdoserer man?',
            duration: '0:46',
            description: 'En praktisk guide til at planlægge og dispensere medicin frem i tiden med TIM.',
            longDescription: 'Hvis en borger skal på weekendtur, til familiebegivenhed eller ud af huset, kan plejepersonalet eller borgeren nemt og sikkert forud-dispensere de nødvendige doser direkte fra maskinen.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/tim-hvordan-fremtidsdosere-man_1.mp4',
            poster: '/Kundebilleder/imgi_6_medicin.png',
            category: 'Funktionsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          },
          {
            id: 'tim-5',
            slug: 'hvordan-faar-man-pn-behovsmedicin-ud',
            aliases: ['tim-5', 'hvordan-faar-man-pn-behovsmedicin-ud', 'behovsmedicin-pn', 'pn-medicin'],
            title: 'd) Hvordan får man Behovsmedicin ud (PN)?',
            duration: '0:46',
            description: 'Sådan håndterer og dispenserer TIM behovsmedicin (PN) sikkert og kontrolleret.',
            longDescription: 'Lær hvordan TIM beskytter borgeren mod overdosering af smertestillende eller beroligende medicin ved hjælp af tidsspærring og faste tidsintervaller for PN-medicin.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/tim-hvordan-faar-man-pn-behovsmedicin_1.mp4',
            poster: '/Kundebilleder/imgi_3_ordination.png',
            category: 'Funktionsvideoer',
            productId: 'tim',
            productName: 'Medimi®Smart (TIM)',
            productPath: '/medimi-smart/tim'
          }
        ]
      }
    ]
  },
  flexsmartapp: {
    productId: 'flexsmartapp',
    badge: 'FlexSmartApp',
    productName: 'FlexSmartApp',
    productPath: '/medimi-smart/flexsmartapp',
    title: 'Se FlexSmartApp i aktion',
    subtitle: 'Se hvordan vores app giver plejepersonale og pårørende fuldt overblik, øjeblikkelige alarmer og tryghed i hverdagen.',
    sections: [
      {
        title: 'App vejledninger',
        videos: [
          {
            id: 'app-1',
            slug: 'flexsmartapp-kom-godt-i-gang',
            aliases: ['app-1', 'flexsmartapp-kom-godt-i-gang', 'kom-godt-i-gang-app'],
            title: 'FlexSmartApp: Kom godt i gang',
            duration: '3:53',
            description: 'En hurtig guide til, hvordan plejepersonale og pårørende logger ind, opsætter profiler og bruger det daglige dashboard.',
            longDescription: 'Få en hurtig og intuitiv introduktion til FlexSmartApp. Lær hvordan du logger ind med MitID/NemLog-in, navigerer i borgerlisten og aflæser medicinstatus på et øjeblik.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/1-hvad-er-tim-underteksterdansk.mp4',
            poster: '/Kundebilleder/imgi_4_omsorgssystem.png',
            category: 'App vejledninger',
            productId: 'flexsmartapp',
            productName: 'FlexSmartApp',
            productPath: '/medimi-smart/flexsmartapp'
          },
          {
            id: 'app-2',
            slug: 'alarmsystem-og-eskalering',
            aliases: ['app-2', 'alarmsystem-og-eskalering', 'alarmer-flexsmartapp'],
            title: 'Alarmsystem og eskalering',
            duration: '1:13',
            description: 'Se hvordan kritiske alarmer sendes og håndteres i appen, hvis en borger overskrider sit medicineringsvindue.',
            longDescription: 'Se hvordan intelligente push-notifikationer og automatiske eskaleringskæder sikrer, at ingen borger glemmes, hvis medicinen ikke er taget inden for det fastsatte tidsvindue.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/mediccare-arbejdskraftbesparende-viral-film-2.mp4',
            poster: '/Kundebilleder/imgi_5_flextech.png',
            category: 'App vejledninger',
            productId: 'flexsmartapp',
            productName: 'FlexSmartApp',
            productPath: '/medimi-smart/flexsmartapp'
          },
          {
            id: 'app-3',
            slug: 'flerbruger-styring-og-overblik',
            aliases: ['app-3', 'flerbruger-styring-og-overblik', 'flerbruger-styring'],
            title: 'Flerbruger-styring og overblik',
            duration: '3:35',
            description: 'Sådan skifter du nemt mellem forskellige borgere i dit distrikt og sikrer fuld dokumentation direkte på farten.',
            longDescription: 'Plejepersonale i rutebiler og distrikter kan let filtrere borgere efter rute, overvåge batteristatus og lagerniveauer på alle enheder i realtid.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/hvad-er-tim-ucl-viser_1.mp4',
            poster: '/Kundebilleder/imgi_6_medicin.png',
            category: 'App vejledninger',
            productId: 'flexsmartapp',
            productName: 'FlexSmartApp',
            productPath: '/medimi-smart/flexsmartapp'
          }
        ]
      }
    ]
  },
  mobili: {
    productId: 'mobili',
    badge: 'Mobili® Bærbar Dispenser',
    productName: 'Mobili® Bærbar Dispenser',
    productPath: '/medimi-smart/mobili',
    title: 'Se Mobili® i aktion',
    subtitle: 'Oplev den bærbare dispenser, der understøtter en aktiv og selvstændig livsstil uden bekymringer om medicintider.',
    sections: [
      {
        title: 'Mobili® instruktioner',
        videos: [
          {
            id: 'mobili-1',
            slug: 'mobili-praesentation',
            aliases: ['mobili-1', 'mob-1', 'mobili-praesentation', 'praesentation-af-mobili'],
            title: 'Præsentation af Mobili®',
            duration: '3:35',
            description: 'En introduktion til den kompakte og bærbare dispenser, dens design og hvordan den bæres sikkert på farten.',
            longDescription: 'Mobili® er designet til borgere med et aktivt liv, som har behov for sikker medicindispensering uden for hjemmet. Se enhedens lette vægt, robuste kapsling og diskrete design.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/hvad-er-tim-ucl-viser_1.mp4',
            poster: '/Kundebilleder/imgi_8_dosering.png',
            category: 'Mobili® instruktioner',
            productId: 'mobili',
            productName: 'Mobili® Bærbar Dispenser',
            productPath: '/medimi-smart/mobili'
          },
          {
            id: 'mobili-2',
            slug: 'mobili-paa-farten-og-gps-tracking',
            aliases: ['mobili-2', 'mob-2', 'mobili-paa-farten-og-gps-tracking', 'gps-tracking-mobili'],
            title: 'Mobili® på farten og GPS-tracking',
            duration: '0:46',
            description: 'Se hvordan GPS-tracking, geofencing og global 4G-forbindelse sikrer borgeren, uanset hvor de befinder sig.',
            longDescription: 'Indbygget GPS og 4G sikrer, at dispenseren altid kender sin position og automatisk advarer personalet eller pårørende, hvis enheden efterlades eller medicin overskrides.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/tim-hvordan-virker-den-1_1.mp4',
            poster: '/Kundebilleder/imgi_7_levering.png',
            category: 'Mobili® instruktioner',
            productId: 'mobili',
            productName: 'Mobili® Bærbar Dispenser',
            productPath: '/medimi-smart/mobili'
          },
          {
            id: 'mobili-3',
            slug: 'mobili-opladning-og-vedligeholdelse',
            aliases: ['mobili-3', 'mob-3', 'mobili-opladning-og-vedligeholdelse', 'opladning-mobili'],
            title: 'Opladning og vedligeholdelse',
            duration: '0:46',
            description: 'En kort og præcis instruktion i opladning via standard USB-C og den daglige håndtering af dispenseren.',
            longDescription: 'Gennemgang af den intuitive magnetiske ladestation, batterilevetid på op til 7 dage samt nem hygiejnisk rengøring af enheden.',
            url: 'https://assets.auxodev.dk/assets/05bb43a3-4ef2-4771-9030-58242fc7345d/tim-hvordan-faar-man-pn-behovsmedicin_1.mp4',
            poster: '/Kundebilleder/imgi_2_medimi.jpg',
            category: 'Mobili® instruktioner',
            productId: 'mobili',
            productName: 'Mobili® Bærbar Dispenser',
            productPath: '/medimi-smart/mobili'
          }
        ]
      }
    ]
  }
};

// Flatten all videos for quick lookup and global listings
export const allVideos = Object.values(videoCatalog).flatMap(product => 
  product.sections.flatMap(section => section.videos)
);

/**
 * Find a video by its unique slug or ID (or any configured alias)
 */
export function getVideoBySlug(slugOrId) {
  if (!slugOrId) return null;
  const normalized = String(slugOrId).toLowerCase().trim();
  
  return allVideos.find(v => 
    v.slug.toLowerCase() === normalized ||
    v.id.toLowerCase() === normalized ||
    (v.aliases && v.aliases.some(a => a.toLowerCase() === normalized))
  ) || null;
}

/**
 * Get the direct watch URL for a video
 */
export function getVideoUrl(video) {
  if (!video) return '/video';
  return `/video/${video.slug}`;
}
